module.exports = __webpack_public_path__ + "assets/wadd.009fdf8834f411fe880563e286d0b993.png";